"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M14 10v-.18l2.01 2.01 5.23-2.44-.63-1.36-4.28 2L14 7.7V6.3l2.33-2.33 4.28 2 .63-1.36-5.23-2.44L14 4.18V4h-2v2H8.82C8.4 4.84 7.3 4 6 4 4.34 4 3 5.34 3 7c0 1.1.6 2.05 1.48 2.58L7.08 18H4v3h13v-3h-3.62L8.41 8.76c.17-.23.31-.48.41-.76H12v2zM6 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
}), 'PrecisionManufacturingSharp');